// loadingHome.jsx
import React, { useState, useEffect } from 'react';
import { useTheme } from '../theme/ThemeContext';
import scatterplotImage from '../static/images/scatterplot_loading.png';
import './widgets/loadingHome.css';

const LoadingHome = ({ isLoading = true }) => {
    const { theme } = useTheme();
    const [loadingText, setLoadingText] = useState('loading');
    const [isVisible, setIsVisible] = useState(true);

    const containerStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.colors.background,
        zIndex: 9999,
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'scale(1)' : 'scale(1.2)',
        transition: 'opacity 0.5s ease-out, transform 0.5s ease-out',
        pointerEvents: isVisible ? 'all' : 'none'
    };

    const backgroundStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: `url(${scatterplotImage})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        filter: 'blur(8px)',
        opacity: 0.6,
        animation: 'pulse 3.5s infinite'
    };

    const contentStyle = {
        position: 'relative',
        padding: '20px 40px',
        zIndex: 1
    };

    const textStyle = {
        color: theme.colors.text,
        fontSize: '2rem',
        fontFamily: 'Arial',
        margin: 0,
        textAlign: 'center'
    };

    useEffect(() => {
        const texts = ['loading', 'loading.', 'loading..', 'loading...'];
        let index = 0;
        const interval = setInterval(() => {
            setLoadingText(texts[index]);
            index = (index + 1) % texts.length;
        }, 500);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (!isLoading) {
            setIsVisible(false);
        }
    }, [isLoading]);

    return (
        <div style={containerStyle}>
            <div style={backgroundStyle} />
            <div style={contentStyle}>
                <h1 style={textStyle}>{loadingText}</h1>
            </div>
        </div>
    );
};

export default LoadingHome;